import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import breakpoints from "@constants/breakpoints"
import {
  smallcapsBold13Styles,
  h4Styles,
  body16MainStyles,
  body18Styles,
} from "@constants/typography"
import { Chevron } from "@components/icons"
import Modal, { ModalBaseProps } from ".."
import Info from "./info"
import { MobileAndTabletOnly, DesktopOnly } from "@utils/MediaQuery"

const Container = styled.div``

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 72px;
  margin-bottom: 40px;
  border-bottom: 1px solid ${colors.dividerLineGray};
  padding: 0 20px;

  @media ${breakpoints.laptop} {
    height: 56px;
    margin-bottom: 100px;
    border-bottom: none;
    padding: 0;
  }
`

const HeaderButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  height: 32px;
  width: 32px;
  transform: rotate(180deg) translateY(1px);
  padding: 0;
  margin-right: 8px;

  @media ${breakpoints.laptop} {
    display: none;
  }
`

const HeaderText = styled.div`
  ${smallcapsBold13Styles}

  @media ${breakpoints.laptop} {
    ${h4Styles}
  }
`

const Content = styled.div`
  padding: 0 20px;

  @media ${breakpoints.laptop} {
    padding: 0;
  }
`

const Banner = styled.div`
  ${h4Styles}
  text-transform: uppercase;
`

const Paragraph = styled.div`
  margin-top: 38px;

  @media ${breakpoints.laptop} {
    margin-top: 60px;
  }
`

const ParagraphTitle = styled.div`
  ${smallcapsBold13Styles}
  margin-bottom: 16px;
`

const ParagraphBody = styled.div`
  ${body16MainStyles}
  color: ${colors.mediumDarkGray};

  @media ${breakpoints.laptop} {
    ${body18Styles}
    color: ${colors.mediumDarkGray};
  }
`

const List = styled.ul`
  padding-inline-start: 20px;
  list-style-type: disc;
`

const ListItem = styled.li`
  padding: 4px 0;
`

const ShippingInfoModal = (props: ModalBaseProps) => (
  <Modal {...props}>
    <Container>
      <MobileAndTabletOnly>
        <Header onClick={props.onRequestClose}>
          <HeaderButton>
            <Chevron strokeColor={colors.black} />
          </HeaderButton>
          <HeaderText>Shipping</HeaderText>
        </Header>
      </MobileAndTabletOnly>
      <DesktopOnly>
        <Header>
          <HeaderText>Shipping Info</HeaderText>
        </Header>
      </DesktopOnly>
      <Content>
        <MobileAndTabletOnly>
          <Banner>Orders over $30 ship free</Banner>
        </MobileAndTabletOnly>
        {Info.map((info) => (
          <Paragraph key={info.title}>
            <ParagraphTitle>{info.title}</ParagraphTitle>
            <ParagraphBody>
              <List>
                {info.items.map((item) => (
                  <ListItem key={item}>{item}</ListItem>
                ))}
              </List>
            </ParagraphBody>
          </Paragraph>
        ))}
      </Content>
    </Container>
  </Modal>
)

export default ShippingInfoModal
